import React from "react";
import {
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  styled,
} from "@mui/material";
import { Column } from "./Table";

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  "&.MuiTableCell-head": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 600,
    textTransform: "uppercase",
    paddingTop: theme.spacing(0.8),
    paddingBottom: theme.spacing(0.8),
    paddingRight: theme.spacing(1.5),
    paddingLeft: theme.spacing(1.5),
  },
  "&.MuiTableCell-body": {
    paddingTop: theme.spacing(0.8),
    paddingBottom: theme.spacing(0.8),
    paddingRight: theme.spacing(1.5),
    paddingLeft: theme.spacing(1.5),
  },
}));

interface TableHeaderProps<T> {
  columns: Column<T>[];
  hasActions: boolean;
  sortBy?: keyof T;
  sortDir?: "asc" | "desc";
  onSortChange?: (field: keyof T) => void;
}

const TableHeader = <T,>({
  columns,
  hasActions,
  sortBy,
  sortDir,
  onSortChange,
}: TableHeaderProps<T>) => (
  <TableHead>
    <TableRow>
      {columns.map((col) => {
        const isSorted = sortBy === col.field;
        const isSortable = col.sortable;

        return (
          <StyledTableCell
            key={String(col.field)}
            sortDirection={isSorted ? sortDir : false}
            sx={{
              cursor: isSortable ? "pointer" : "default",
              "&:hover": {
                backgroundColor: isSortable
                  ? (theme) => theme.palette.primary.dark
                  : undefined,
              },
            }}
            onClick={isSortable ? () => onSortChange?.(col.field) : undefined}
          >
            {isSortable ? (
              <TableSortLabel
                active={isSorted}
                direction={isSorted ? sortDir : "asc"}
                hideSortIcon={false}
                sx={{
                  color: (theme) => theme.palette.primary.contrastText,
                  "&.Mui-active": {
                    color: (theme) => theme.palette.info.light,
                    "& .MuiTableSortLabel-icon": {
                      color: (theme) => theme.palette.info.light,
                      opacity: 1,
                    },
                  },
                  "&:hover": {
                    color: (theme) => theme.palette.primary.contrastText,
                    "& .MuiTableSortLabel-icon": {
                      color: (theme) => theme.palette.primary.contrastText,
                    },
                  },
                  "& .MuiTableSortLabel-icon": {
                    opacity: 0.7,
                  },
                }}
              >
                {col.headerName}
              </TableSortLabel>
            ) : (
              col.headerName
            )}
          </StyledTableCell>
        );
      })}
      {hasActions && (
        <StyledTableCell sx={{ color: "white" }}></StyledTableCell>
      )}
    </TableRow>
  </TableHead>
);

export default TableHeader;
